import { defineComponent } from 'vue'

export default defineComponent ({
    name: 'ErrorComponent'
    , props: { code: Number }
    , data: () => ({
        processingMessage: 1
        , processingLink: 1
        , text: ''
        , link: 'Presione aquí para ir a la página de inicio'
    })
    , computed: {
         characters () {
            return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-=+<>,./?[{()}]!@#$%^&*~'.split('')
        }
        , statusCodes () {
             return {
                 400: 'Bad Request'
                 , 401: 'Unauthorized'
                 , 403: 'Forbidden'
                 , 404: 'Not Found'
             }
        }
    }
    , beforeMount () {
        this.loadScramble()
    }
    , methods: {
        setCharAt (
            str
            ,index
            ,chr
        ) {
            if(index > str.length - 1) return str
            return str.substr(0, index) + chr + str.substr(index + 1)
        }
        , goHome () {
            if (this.canWithCode('business-partner')) return this.$router.push({ name: 'SelectModule' })
            return this.$router.push({ name: 'HomeOnboarding' })
        }
        , loadScramble () {
            const message = this.statusCodes[this.code] || 'Lo siento no funciona'
            this.text = (this.code + (', '.concat(message).concat('!')))
            const totalError = this.text.length
            const totalLink = this.link.length
            const value_message = this.text
            const value_link = this.link

            const scrambleInterval = setInterval(() => {
                let error = this.text
                let link = this.link

                for (let i = 1; i < totalError; i++) {
                    if (i >= this.processingMessage) {
                        error = this.setCharAt(error, i, this.characters[Math.round(Math.random() * (this.characters.length - 1))])
                    }
                }

                for (let i = 1; i < totalLink; i++) {
                    if (i >= this.processingLink) {
                        link = this.setCharAt(link, i, this.characters[Math.round(Math.random() * (this.characters.length - 1))])
                    }
                }

                this.text = error
                this.link = link
            }, 1000 / 60)

            setTimeout(() => {
                const revealInterval = setInterval(() => {
                    if (this.processingMessage < totalError) {
                        this.processingMessage++
                    } else if (this.processingLink < totalLink) {
                        this.processingLink++
                        this.text = value_message
                    } else {
                        this.link = value_link
                        clearInterval(revealInterval)
                        clearInterval(scrambleInterval)
                    }
                }, 50)
            }, 1000)
        }
    }
})